
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dry-eye",
      function () {
        return require("private-next-pages/dry-eye.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dry-eye"])
      });
    }
  